import { useState } from "react";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Rajdhani:wght@400;500;600;700&family=Orbitron:wght@400;600;700;900&display=swap');

  .skills-section {
    position: relative;
    z-index: 1;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 100px 4rem 80px;
    font-family: 'Rajdhani', sans-serif;
  }

  .skills-container {
    width: 100%;
    max-width: 1100px;
    margin: 0 auto;
  }

  /* HEADER */
  .skills-header {
    text-align: center;
    margin-bottom: 4rem;
  }

  .skills-label {
    font-family: 'Orbitron', monospace;
    font-size: 0.65rem;
    font-weight: 600;
    color: #ff8c00;
    letter-spacing: 5px;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    margin-bottom: 1rem;
    opacity: 0;
    animation: skillsFadeUp 0.7s ease 0.1s both;
  }
  .skills-label::before, .skills-label::after { content: ''; width: 50px; height: 1px; }
  .skills-label::before { background: linear-gradient(to right, transparent, #ff8c00); }
  .skills-label::after  { background: linear-gradient(to left,  transparent, #ff8c00); }

  .skills-title {
    font-family: 'Orbitron', monospace;
    font-size: clamp(1.8rem, 4vw, 2.8rem);
    font-weight: 900;
    background: linear-gradient(135deg, #ffffff 0%, #38c8ff 60%, #00aaff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    filter: drop-shadow(0 0 20px rgba(0,170,255,0.3));
    opacity: 0;
    animation: skillsFadeUp 0.7s ease 0.2s both;
  }

  /* CATEGORY TABS */
  .skills-tabs {
    display: flex;
    justify-content: center;
    gap: 0.5rem;
    margin-bottom: 3rem;
    flex-wrap: wrap;
    opacity: 0;
    animation: skillsFadeUp 0.7s ease 0.3s both;
  }

  .skills-tab {
    padding: 0.5rem 1.5rem;
    background: transparent;
    color: #4a7a9b;
    font-family: 'Orbitron', monospace;
    font-size: 0.65rem;
    font-weight: 600;
    letter-spacing: 2px;
    text-transform: uppercase;
    border: 1px solid rgba(0,170,255,0.15);
    cursor: pointer;
    clip-path: polygon(8px 0%, 100% 0%, calc(100% - 8px) 100%, 0% 100%);
    transition: all 0.3s;
  }

  .skills-tab:hover {
    color: #00aaff;
    border-color: rgba(0,170,255,0.4);
  }

  .skills-tab.active {
    background: rgba(0,170,255,0.1);
    color: #00aaff;
    border-color: rgba(0,170,255,0.5);
    box-shadow: 0 0 15px rgba(0,170,255,0.15);
  }

  /* MAIN LAYOUT */
  .skills-layout {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
    opacity: 0;
    animation: skillsFadeUp 0.7s ease 0.4s both;
  }

  /* SKILL CATEGORY CARD */
  .skill-cat-card {
    background: rgba(0, 20, 50, 0.5);
    border: 1px solid rgba(0,170,255,0.12);
    border-top: 2px solid #00aaff;
    padding: 1.8rem;
    position: relative;
    transition: border-color 0.3s, box-shadow 0.3s;
  }

  .skill-cat-card:hover {
    border-color: rgba(0,170,255,0.3);
    box-shadow: 0 0 25px rgba(0,170,255,0.08);
  }

  .skill-cat-card.orange-top { border-top-color: #ff8c00; }

  .skill-cat-card::before {
    content: '';
    position: absolute;
    top: -2px; left: 0; right: 0;
    height: 2px;
    background: linear-gradient(to right, #00aaff, transparent);
  }

  .skill-cat-card.orange-top::before {
    background: linear-gradient(to right, #ff8c00, transparent);
  }

  .skill-cat-header {
    display: flex;
    align-items: center;
    gap: 0.8rem;
    margin-bottom: 1.5rem;
  }

  .skill-cat-icon {
    width: 38px;
    height: 38px;
    background: rgba(0,170,255,0.08);
    border: 1px solid rgba(0,170,255,0.25);
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    flex-shrink: 0;
  }

  .skill-cat-name {
    font-family: 'Orbitron', monospace;
    font-size: 0.75rem;
    font-weight: 700;
    color: #00aaff;
    letter-spacing: 2px;
    text-transform: uppercase;
  }

  .skill-cat-name.orange { color: #ffaa33; }

  /* SKILL BARS */
  .skill-bars {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .skill-bar-row {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
  }

  .skill-bar-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .skill-name {
    font-size: 0.9rem;
    font-weight: 600;
    color: rgba(232,244,255,0.75);
    letter-spacing: 0.5px;
  }

  .skill-pct {
    font-family: 'Orbitron', monospace;
    font-size: 0.65rem;
    color: #00aaff;
  }

  .skill-pct.orange { color: #ffaa33; }

  .skill-track {
    height: 3px;
    background: rgba(0,170,255,0.08);
    border-radius: 2px;
    overflow: hidden;
    position: relative;
  }

  .skill-fill {
    height: 100%;
    border-radius: 2px;
    background: linear-gradient(to right, #00aaff, #38c8ff);
    box-shadow: 0 0 8px rgba(0,170,255,0.5);
    animation: fillGrow 1.4s ease both;
    transform-origin: left;
  }

  .skill-fill.orange-fill {
    background: linear-gradient(to right, #ff8c00, #ffaa33);
    box-shadow: 0 0 8px rgba(255,140,0,0.5);
  }

  /* TECH TAGS GRID */
  .skill-tags-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .skill-tag {
    background: rgba(0,170,255,0.06);
    border: 1px solid rgba(0,170,255,0.18);
    border-radius: 4px;
    padding: 0.3rem 0.8rem;
    font-size: 0.82rem;
    color: rgba(232,244,255,0.6);
    transition: all 0.3s;
    cursor: default;
  }

  .skill-tag:hover {
    border-color: rgba(0,170,255,0.5);
    color: #e8f4ff;
    background: rgba(0,170,255,0.1);
  }

  .skill-tag.orange-tag {
    background: rgba(255,140,0,0.05);
    border-color: rgba(255,140,0,0.18);
    color: rgba(255,200,100,0.65);
  }

  .skill-tag.orange-tag:hover {
    border-color: rgba(255,140,0,0.5);
    color: #ffaa33;
    background: rgba(255,140,0,0.1);
  }

  /* SOFT SKILLS ROW */
  .soft-skills-row {
    margin-top: 2rem;
    opacity: 0;
    animation: skillsFadeUp 0.7s ease 0.6s both;
  }

  .soft-skills-label {
    font-family: 'Orbitron', monospace;
    font-size: 0.65rem;
    color: #00aaff;
    letter-spacing: 3px;
    text-transform: uppercase;
    text-align: center;
    margin-bottom: 1.2rem;
  }

  .soft-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1rem;
  }

  .soft-card {
    background: rgba(0, 20, 50, 0.5);
    border: 1px solid rgba(0,170,255,0.12);
    padding: 1.2rem 1rem;
    text-align: center;
    position: relative;
    transition: all 0.3s;
    cursor: default;
  }

  .soft-card::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 1px;
    background: linear-gradient(to right, transparent, rgba(0,170,255,0.4), transparent);
  }

  .soft-card:hover {
    border-color: rgba(0,170,255,0.3);
    box-shadow: 0 0 18px rgba(0,170,255,0.1);
    transform: translateY(-3px);
  }

  .soft-icon {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
    display: block;
  }

  .soft-name {
    font-family: 'Orbitron', monospace;
    font-size: 0.6rem;
    font-weight: 700;
    color: #00aaff;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  @keyframes skillsFadeUp {
    from { opacity: 0; transform: translateY(24px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  @keyframes fillGrow {
    from { transform: scaleX(0); }
    to   { transform: scaleX(1); }
  }

  @media (max-width: 900px) {
    .skills-section { padding: 100px 2rem 60px; }
    .skills-layout { grid-template-columns: 1fr; }
    .soft-grid { grid-template-columns: repeat(2, 1fr); }
  }
`;

const SKILL_CATEGORIES = [
  {
    id: "programming",
    icon: "💻",
    name: "Programming Languages",
    orange: false,
    type: "bars",
    skills: [
      { name: "C / C++", pct: 80 },
      { name: "Python", pct: 85 },
      { name: "Java", pct: 65 },
      { name: "JavaScript", pct: 65 },
      { name: "MATLAB", pct: 60 },
    ],
  },
  {
    id: "web",
    icon: "🌐",
    name: "Web & Frameworks",
    orange: true,
    type: "bars",
    skills: [
      { name: "ReactJS", pct: 85 },
      { name: "HTML / CSS", pct: 70 },
      { name: "Node.js", pct: 85 },
    ],
  },
  {
    id: "hardware",
    icon: "🔧",
    name: "Hardware & Embedded",
    orange: false,
    type: "tags",
    skills: [
      "ESP32", "Arduino",
      "System Verilog / RTL", "Digital Logic Design",
      "Circuit Design", 
    ],
  },
  {
    id: "tools",
    icon: "🛠️",
    name: "Tools & Platforms",
    orange: true,
    type: "tags",
    skills: [
      "Git / GitHub", "VS Code", "MS Office", "Arduino IDE",
      "MATLAB", "Canva",
    ],
  },
];

const SOFT_SKILLS = [
  { icon: "🧠", name: "Problem Solving" },
  { icon: "🤝", name: "Teamwork" },
  { icon: "💬", name: "Communication" },    
  { icon: "🔄", name: "Adaptability" },
  { icon: "⏱️", name: "Time Management" },
  { icon: "🎯", name: "Detail-Oriented" },
];

export default function Skills() {
  const [activeTab, setActiveTab] = useState("All");
  const tabs = ["All", "Programming", "Hardware", "Web", "Tools"];

  const visibleCategories =
    activeTab === "All"
      ? SKILL_CATEGORIES
      : SKILL_CATEGORIES.filter((c) =>
          c.id.toLowerCase().includes(activeTab.toLowerCase()) ||
          c.name.toLowerCase().includes(activeTab.toLowerCase())
        );

  return (
    <section className="skills-section" id="skills">
      <style>{styles}</style>
      <div className="skills-container">

        {/* Header */}
        <div className="skills-header">
          <p className="skills-label">Technical Arsenal</p>
          <h2 className="skills-title">Skills</h2>
        </div>

        {/* Tabs */}
        <div className="skills-tabs">
          {tabs.map((tab) => (
            <button
              key={tab}
              className={`skills-tab ${activeTab === tab ? "active" : ""}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Skill Cards Grid */}
        <div className="skills-layout">
          {visibleCategories.map((cat, i) => (
            <div
              className={`skill-cat-card ${cat.orange ? "orange-top" : ""}`}
              key={cat.id}
            >
              <div className="skill-cat-header">
                <div className="skill-cat-icon">{cat.icon}</div>
                <p className={`skill-cat-name ${cat.orange ? "orange" : ""}`}>
                  {cat.name}
                </p>
              </div>

              {cat.type === "bars" ? (
                <div className="skill-bars">
                  {cat.skills.map((s, j) => (
                    <div className="skill-bar-row" key={j}>
                      <div className="skill-bar-top">
                        <span className="skill-name">{s.name}</span>
                        <span className={`skill-pct ${cat.orange ? "orange" : ""}`}>
                          {s.pct}%
                        </span>
                      </div>
                      <div className="skill-track">
                        <div
                          className={`skill-fill ${cat.orange ? "orange-fill" : ""}`}
                          style={{
                            width: `${s.pct}%`,
                            animationDelay: `${0.4 + j * 0.1}s`,
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="skill-tags-grid">
                  {cat.skills.map((s, j) => (
                    <span
                      key={j}
                      className={`skill-tag ${cat.orange ? "orange-tag" : ""}`}
                    >
                      {s}
                    </span>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Soft Skills */}
        <div className="soft-skills-row">
          <p className="soft-skills-label">// Soft Skills</p>
          <div className="soft-grid">
            {SOFT_SKILLS.map((s, i) => (
              <div className="soft-card" key={i}>
                <span className="soft-icon">{s.icon}</span>
                <p className="soft-name">{s.name}</p>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}